import styled, { css } from 'styled-components';
import { COLOR_GREEN, COLOR_BLACK } from '../../../../../assets/styles/colors';
import { rgba } from 'polished';

export const OptionsSC = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 5px 12px;
  background: white;
`;

export const StateCheckboxSC = styled.button`
  width: 20px;
  height: 20px;
  border: 1px solid transparent;
  border-radius: 10px;
  margin: 0;
  margin-right: 16px;

  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;

  font-weight: bold;
  background: white;

  ${({ checked }) =>
    checked
      ? css`
          border-color: ${COLOR_GREEN};
          color: white;
        `
      : css`
          border-color: ${rgba(COLOR_BLACK, 0.2)};
        `}
`;
